<template>
  <div class="loader_container" v-if="loading">
    <div class="loader">
      <div class="spinner-border" data-chromatic="ignore">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useLoadingStore } from '@app/stores/LoadingStore'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(useLoadingStore, ['loading']),
    ...mapState(useLoadingStore, ['loaderQueue']),
  },
}
</script>
<style lang="sass" scoped>
.loader_container
  position: absolute
  display: flex
  align-items: center
  justify-content: center
  width: 100vw
  height: 100vh
  background: rgba(255, 255, 255, 0.8)
  top: 0px
  left: 0px
  z-index: 10000000
  .spinner-border
    color: var(--uePurple)
    width: 3rem
    height: 3rem
</style>
